import React from 'react';
import Link, { LinkProps } from '@mui/material/Link';
import useBundleTranslation from 'i18n';

export default function LLMLogLink({
    sessionUid,
    underline,
}: {
    sessionUid: string;
    underline?: LinkProps['underline'];
}) {
    const { t } = useBundleTranslation(['app/concierge/widget']);

    const onClick = () => {
        window.MiNamespace.render({ component: 'concierge_llm_log', props: { session_uid: sessionUid } });
    };
    return (
        <Link sx={{ cursor: 'pointer' }} underline={underline} onClick={onClick} data-test="llm_log_link">
            {t('llm_log')}
        </Link>
    );
}
